import React, { Component } from "react";
import { connect } from "react-redux";
import ShapedBox from "../../common/ShapedBox";
import {
    fetchAllActivities,
} from '../../api/checkIn';
import { path } from "ramda";
import './style.css';
import Preloader from "../../common/Preloader";
import Breadcrumbs from "../../common/Breadcrumbs";
import { fetchWorker } from "../../api/employees";

class SelectActivity extends Component {
    componentDidMount() {
        const { userid } = this.props.location.state;
        this.props.loadWorker(userid);
        this.props.fetchActivities();
    }


    render() {
        const { userid } = this.props.location.state;

        const activities = path(['checkIn', 'activities'], this.props);

        const worker = path(['employees', 'worker'], this.props);
        const workerFullname = worker ? `${worker.firstname} ${worker.lastname}` : '';

        return (
            <div>
                <Breadcrumbs
                    list={[
                        { url: '/pages/check-in', icon: 'perm_contact_calendar', name: 'Check In' },
                        { url: '/pages/check-in', icon: 'person', name: `${workerFullname}` },
                        { url: '/pages/check-in', icon: 'assignment', name: 'New Work' },
                    ]}
                />
                <div className="card">
                    <div className="card-header rounded-top">Choose Activity</div>
                    <div className="card-block">
                        <div className="d-flex justify-content-end align-items-center">
                            <div>
                                <button
                                    className="btn btn-rounded btn-icon ui-btn pull-right m-l-10"
                                    onClick={() => this.props.history.push(`/pages/check-in/${userid}`)}
                                >Cancel</button>
                                <button
                                    className="btn btn-rounded btn-icon ui-btn pull-right"
                                    onClick={() => this.props.history.goBack()}
                                >Back</button>
                            </div>
                        </div>
                        {!!activities ?
                            <div className="d-flex justify-content-start flex-wrap list">
                                {activities.map((activity, index) => {
                                    return (
                                        <ShapedBox shape="circle"
                                            onClick={() => this.props.history.push(`/pages/check-in/${userid}/confirm`, { ...this.props.location.state, activity })}>
                                            <div className="text-lg">{activity.label.toUpperCase()}</div>
                                        </ShapedBox>
                                    )
                                })}
                            </div>
                            :
                            <Preloader
                                show={true}
                                type={'circle'}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchActivities: () => {
            fetchAllActivities()(dispatch);
        },
        loadWorker: (workerId) => {
            fetchWorker(workerId)(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectActivity);



// WEBPACK FOOTER //
// ./src/containers/SelectActivity/index.js